import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ContractDetailType } from "../../requests_cm/gecoContractsService/types";

const initialState: {
	contractSearch: string;
	contractPeriodSearch: string;
	contractValues: ContractDetailType[];
	contractPeriodValues: ContractDetailType[];
} = {
	contractSearch: "",
	contractPeriodSearch: "",
	contractValues: [],
	contractPeriodValues: [],
};

const timeseriesPageSlice = createSlice({
	name: "timeseriesPage",
	initialState,
	reducers: {
		updateContractSearch: (state, action: PayloadAction<string>) => {
			state.contractSearch = action.payload;
		},
		updateContracts: (
			state,
			action: PayloadAction<ContractDetailType[]>
		) => {
			state.contractValues = action.payload;
		},
		updateContractPeriodSearch: (state, action: PayloadAction<string>) => {
			state.contractPeriodSearch = action.payload;
		},
		updateContractPeriods: (
			state,
			action: PayloadAction<ContractDetailType[]>
		) => {
			state.contractPeriodValues = action.payload;
		},
	},
});

export const {
	updateContractSearch,
	updateContractPeriodSearch,
	updateContracts,
	updateContractPeriods,
} = timeseriesPageSlice.actions;

export default timeseriesPageSlice.reducer;
